var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DefaultWidget", {
    attrs: {
      name: "替换更新链接",
      icon: "mdi-file-replace-outline",
      disabled: _vm.busy,
    },
    on: {
      click: function ($event) {
        return _vm.replaceBranch()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }